module.exports = __webpack_public_path__ + "img/bg-chat-tips-left.100ee004.png";